module.exports = __webpack_public_path__ + "static/media/programmers-must-read-books.5aacfc9b.md";